import * as React from "react";
import type { SVGProps } from "react";
const SvgMonitor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 20a1 1 0 1 0 0 2zm8 2a1 1 0 1 0 0-2zm-3-5a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zM4 4h16V2H4zm16 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v10h2V5zm0 10a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H4v2h16zM4 16a1 1 0 0 1-1-1H1a3 3 0 0 0 3 3zm-1-1V5H1v10zM3 5a1 1 0 0 1 1-1V2a3 3 0 0 0-3 3zm5 17h8v-2H8zm3-5v4h2v-4z"
    />
  </svg>
);
export default SvgMonitor;
